import React, { Suspense, useEffect, useState } from "react"
import TopbarViewerActions from "components/TopbarViewerActions"
import { currentUser } from "lib/currentUser"
import { isSessionActive } from "lib/currentUser/session"

const AccountMenu = React.lazy(() => import("components/AccountMenu"))

/**
 * Maps the /users/current response to the props TopbarViewerActions and AccountMenu take.
 *
 * @param {Object} current
 * @returns {{userRole: string, user: (Object|undefined), adminActions: Array}}
 */
const toViewerProps = (current) => {
  const adminActions = (current.admin_actions || []).map(
    ({ track_action: trackAction, ...action }) => ({
      ...action,
      trackAction,
    }),
  )

  if (!current.id) {
    return { userRole: "Reader", user: undefined, adminActions }
  }

  return {
    userRole: current.type,
    adminActions,
    user: {
      id: String(current.id),
      name: current.full_name,
      avatar: current.avatar_url,
      newsFeedCount: current.news_feed_count,
      commentNotificationCount: current.comment_notification_count,
      allow: {
        analytics: current.allow.analytics,
        moderateComments: current.allow.moderate_comments,
      },
    },
  }
}

const AuthenticatedTopbarContent = () => {
  const [viewerProps, setViewerProps] = useState(null)

  useEffect(() => {
    let cancelled = false

    currentUser()
      .then((current) => {
        if (!cancelled) setViewerProps(toViewerProps(current))
      })
      .catch(() => {})

    return () => {
      cancelled = true
    }
  }, [])

  if (!viewerProps) {
    return null
  }

  return (
    <Suspense fallback={null}>
      <TopbarViewerActions {...viewerProps} />
      <AccountMenu {...viewerProps} />
    </Suspense>
  )
}

const TopbarDynamicContent = () => {
  if (!isSessionActive()) {
    return <TopbarViewerActions />
  }

  return <AuthenticatedTopbarContent />
}

export default TopbarDynamicContent
